import { Stack, useTheme, useMediaQuery, Typography } from "@mui/material";
import FormsIcon from "../FormsIcon";

export default function NoForms() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Stack alignItems="center" direction={isMobile ? "column" : "row"}>
            <FormsIcon />
            <Stack direction="column" spacing={2} justifyContent="center">
                <Typography
                    variant="h6"
                    sx={{
                        textAlign: isMobile ? "center" : "left",
                    }}
                    data-test-id="header_text"
                >
                    You don&apos;t have any forms yet
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        textAlign: isMobile ? "center" : "left",
                    }}
                    data-test-id="decription_text"
                >
                    When you receive forms, they&apos;ll appear here for easy access. Stay organized and keep track of
                    everything in one place.
                </Typography>
            </Stack>
        </Stack>
    );
}
